"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    simulate: function() {
        return simulate;
    }
});
const _weighted = /*#__PURE__*/ _interop_require_default(require("weighted"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getPercentageAmount = (total, points)=>points / total * 100;
function simulate(items) {
    const groupIds = items.map((e)=>e.groupId);
    if (groupIds && groupIds.length > 1) {
        const total = items.reduce((prev, next)=>prev + next?.model?.points || 1, 0);
        const weights = {};
        items.forEach((item)=>{
            const points = item?.manager ? 0 : item?.model?.points || 1;
            weights[item.wrestlerId] = getPercentageAmount(total, points);
        });
        const winnerId = _weighted.default.select(weights);
        const winninggroupId = items.find((item)=>item.wrestlerId === winnerId)?.groupId;
        items = items.map((item)=>{
            const winner = item.groupId === winninggroupId;
            item.winner = winner;
            return item;
        });
    }
    return items;
}
const _default = simulate;
